module.exports = __webpack_public_path__ + "img/G5.849b0ce9.jpg";